<!--
 * @Author: guoyu
 * @Date: 2021-03-08 14:52:21
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-10-09 16:01:39
 * @Description: 提领账户信息编辑
-->
<template>
  <div class="withdraw-account-page">
    <el-form :model="applyForm" :rules="rules" ref="applyForm">
      <div class="PersonalData">
        <div class="PersonalData_title">
          <span>個人資料</span>
        </div>
        <el-form-item label="真實姓名" prop="accountUserName">
          <el-input
            v-model="applyForm.accountUserName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份證字號" prop="identityNo">
          <el-input
            v-model="applyForm.identityNo"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="戶籍地址" prop="Permanent">
          <el-input v-model="applyForm.Permanent" autocomplete="off"></el-input>
        </el-form-item>
        <div class="UploadIDCard">
          <div class="UploadIDCard_Positive">
            <span class="Positive_title">身份證正面相片</span>
            <el-upload
              class="avatar-uploader"
              action="https://api.dev.nicee.app/basic/image/upload"
              :show-file-list="false"
              :http-request="handleAvatarSuccessP"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="identityFrontImg"
                :src="identityFrontImg"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div
              v-show="!dialogImageUrlP"
              slot="tip"
              class="el-upload__text upload__tip"
            >
              請上傳身份證正面相片
            </div>
          </div>
          <div class="UploadIDCard_Verso">
            <span class="Verso_title">身份證反面相片</span>
            <el-upload
              class="avatar-uploader"
              action="https://api.dev.nicee.app/basic/image/upload"
              :show-file-list="false"
              :http-request="handleAvatarSuccessO"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="identityBackImg"
                :src="identityBackImg"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div
              v-show="!dialogImageUrlO"
              slot="tip"
              class="el-upload__text upload__tip"
            >
              請上傳身份證反面相片
            </div>
          </div>
          <div class="IDCard_dec">
            <p>請保證相片清晰</p>
            <p>支持格式：jpg，jpeg，png</p>
            <p>文件大小不要超過3M</p>
          </div>
        </div>
      </div>
      <div class="BankInformation">
        <div class="BankInformation_title">
          <span>銀行資料</span>
        </div>
        <el-form-item label="銀行名稱" prop="bankName">
          <el-select v-model="applyForm.bankName" placeholder="請選擇">
            <el-option
              v-for="(bank, index) in bankList"
              :key="index"
              :label="bank.bankCode + ' ' + bank.bankName"
              :value="bank.bankCode + ' ' + bank.bankName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="
            isPaypal
              ? '用戶名'
              : isWechat
              ? '微信暱稱'
              : isAlipay
              ? '支付寶名稱'
              : '分行名稱'
          "
          prop="branchName"
        >
          <el-input
            v-model="applyForm.branchName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="
            isPaypal
              ? '電子郵箱'
              : isWechat
              ? '微信號'
              : isAlipay
              ? '支付寶號'
              : '帳戶號碼'
          "
          prop="accountNo"
        >
          <el-input v-model="applyForm.accountNo" autocomplete="off"></el-input>
        </el-form-item>

        <div v-show="!isPaypal" class="uploadBankbook">
          <div class="bankbook_title">
            {{
              isWechat
                ? '微信帳號頁面截圖'
                : isAlipay
                ? '支付寶賬號頁面截圖'
                : '存摺信息頁'
            }}
            <template v-if="!isWechat && !isAlipay">
              （<b style="font-weight:normal;color:red;">*帶銀行帳號的頁面</b>）
            </template>
          </div>
          <div class="bankbook">
            <el-upload
              class="avatar-uploader"
              action="https://api.dev.nicee.app/basic/image/upload"
              :show-file-list="false"
              :http-request="handleBankbookSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="bankbookImg" :src="bankbookImg" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div
              v-show="!dialogImageUrlB"
              slot="tip"
              class="el-upload__text upload__tip"
            >
              {{
                isWechat
                  ? '請上傳微信帳號截圖'
                  : isAlipay
                  ? '請上傳支付寶帳號截圖'
                  : '請上傳存摺封面圖'
              }}
            </div>
          </div>
          <div class="example-image">
            <p class="show-exist">示例：</p>
            <el-image
              :style="{
                transfrom: 0.75
              }"
              class="show-exist-img"
              :src="bankbookExisturl"
              alt=""
              :preview-src-list="bankbookExisturlArr"
            />
            <div class="IDCard_dec">
              <p>請保證相片清晰</p>
              <p>
                {{
                  isWechat
                    ? '請上傳微信帳號封面圖'
                    : isAlipay
                    ? '請上傳支付寶帳號封面圖'
                    : '請上傳帶銀行帳號的存摺頁面'
                }}
              </p>
              <p>支持格式：jpg，jpeg，png</p>
              <p>文件大小不要超過3M</p>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <NButton
      class="submit-button"
      @click="confirmApplyBank"
      :loading="isLoading"
      :disabled="reviewStatus === 'Applying'"
      >提交認證审核</NButton
    >
  </div>
</template>
<script>
import { saveBankInfo, getBankInfo } from '@/api';
import { uploadImageToS3 } from '@/api';
import bankList from './bank.js';
import NButton from '@/components/common/button/normal.vue';
export default {
  name: 'WithdrawBenefit',
  components: {
    NButton
  },
  data() {
    return {
      INFO_KEY: 'WITHDRAW_INFO_KEY',
      bankList: bankList,
      isLoading: false,
      bankbookExisturl: require('@/assets/images/bankbook.png'),
      bankbookExisturlArr: [require('@/assets/images/bankbook.png')],
      dialogImageUrlB: true,
      identityBackImg: '',
      bankbookImg: '',
      identityFrontImg: '',
      dialogImageUrlO: true,
      dialogImageUrlP: true,
      applyForm: {
        accountNo: '',
        accountUserName: '',
        bankName: '',
        branchName: '',
        identityNo: '',
        Permanent: ''
      },
      accountId: '',
      reviewStatus: false
    };
  },
  computed: {
    rules() {
      const {
        isAccountNo,
        isAccountUserName,
        isEmail,
        isPaypalName,
        isBranchName,
        isIdentity,
        isPermanent,
        isPaypal,
        donotNeed,
        isWechat,
        isWechatValid,
        isChinaIdentify,
        isAlipay,
        isAlipayValid
      } = this;
      let rs = {
        accountNo: [
          {
            required: true,
            message: isPaypal
              ? '請正確填寫您的Paypal電子郵箱'
              : isWechat
              ? '請正確填寫你的微信帳號'
              : isAlipay
              ? '請正確填寫你的支付寶帳號'
              : '請正確填寫您的帳戶號碼（只允許數字，10-14位之間）',
            trigger: 'blur'
          },
          {
            validator: isPaypal
              ? isEmail
              : isWechat
              ? isWechatValid
              : isAlipay
              ? isAlipayValid
              : isAccountNo,
            trigger: 'blur'
          }
        ],
        accountUserName: [
          {
            required: true,
            message: isWechat
              ? '身份證姓名不能為空'
              : isAlipay
              ? '身份證姓名不能為空'
              : '身份證姓名需與銀行資料開戶名相同',
            trigger: 'blur'
          },
          { validator: isAccountUserName, trigger: 'blur' }
        ],
        bankName: [
          {
            required: true,
            message: '請選擇您的銀行名稱与代码',
            trigger: 'blur'
          }
        ],
        branchName: [
          {
            required: true,
            message: isPaypal
              ? '請正確填寫您的Paypal用戶名'
              : isWechat
              ? '請正確填寫您的Wechat用戶名'
              : isAlipay
              ? '請正確填寫您的支付寶用戶名'
              : '請正確填寫您的分行名稱（上限20個字符）',
            trigger: 'blur'
          },
          {
            validator: isPaypal
              ? isPaypalName
              : isWechat
              ? isWechatValid
              : isAlipay
              ? isAlipayValid
              : isBranchName,
            trigger: 'blur'
          }
        ],
        Permanent: [
          {
            required: true,
            message: '請正確填寫您的戶籍地址',
            trigger: 'blur'
          },
          { validator: isPermanent, trigger: 'blur' }
        ],
        identityNo: [
          {
            required: true,
            message: '請正確填寫您的身份證字號',
            trigger: 'blur'
          },
          {
            validator: isPaypal
              ? donotNeed
              : isWechat
              ? isChinaIdentify
              : isAlipay
              ? isChinaIdentify
              : isIdentity,
            trigger: 'blur'
          }
        ]
      };
      return rs;
    },
    isPaypal() {
      return this.applyForm.bankName === '00000 Paypal';
    },
    isWechat() {
      return this.applyForm.bankName === 'wechat 微信提領';
    },
    isAlipay() {
      return this.applyForm.bankName === 'zfb 支付寶提領';
    }
  },
  methods: {
    confirmApplyBank() {
      return this.$confirm({
        content: '提交修改後，在資料驗證期間內容無法編輯',
        confirmButtonText: '去認證',
        cancelButtonText: '再想想'
      })
        .then(() => {
          this.submitForm();
        })
        .catch(() => {
          return false;
        });
    },
    initData() {
      let loads = this.$loading();
      getBankInfo()
        .then(res => {
          let blankInfo = this.$util.getVal(res, 'data.0');
          loads.close();
          if (!blankInfo) {
            this.initLocal();
            return;
          }
          if (blankInfo.reviewStatus === 'Applying') {
            this.$router.back();
            return;
          }
          this.applyForm = {
            accountNo: blankInfo.accountNo,
            accountUserName: blankInfo.accountUserName,
            bankName: blankInfo.bankName,
            branchName: blankInfo.branchName,
            identityNo: blankInfo.identityNo,
            Permanent: blankInfo.address
          };
          this.identityFrontImg = blankInfo.identityFrontImg;
          this.identityBackImg = blankInfo.identityBackImg;
          this.bankbookImg = blankInfo.bankbookImg;
          this.accountId = blankInfo.id;
        })
        .catch(e => {
          console.error(e);
          loads.close();
        });
    },
    initLocal() {
      const applyFormStr = localStorage.getItem(this.NFO_KEY);
      if (applyFormStr) {
        this.applyForm = JSON.parse(applyFormStr);
      }
    },
    isEmail(rule, value, callback) {
      let regEn = /^(\w+\.)*\w+@\w+(.\w+)+$/;
      if (regEn.test(value)) {
        callback();
      } else {
        callback(new Error('電子郵箱不符合規則'));
      }
    },
    donotNeed(rule, value, callback) {
      callback();
    },
    isPaypalName(rule, value, callback) {
      if (value.length > 20) {
        callback(new Error('請輸入1-20位字符'));
      }
      callback();
    },
    isWechatValid(rule, value, callback) {
      if (value.length) {
        callback();
      } else {
        callback(new Error('微信信息不能為空'));
      }
    },
    isAlipayValid(rule, value, callback) {
      if (value.length) {
        callback();
      } else {
        callback(new Error('支付寶信息不能為空'));
      }
    },

    isAccountNo(rule, value, callback) {
      let regEn = /^[^\u4e00-\u9fff]{10,14}$/;
      if (!regEn.test(value)) {
        callback(new Error('請輸入10~14位数字'));
      }
      callback();
    },
    isAccountUserName(rule, value, callback) {
      // 对𤤂这样的特殊字符进行处理
      const result = value.match(/[𤤂]/);
      let regEn = '';
      if (result && result.length) {
        regEn = /^[(\u4e00-\u9fff) | 𤤂]{3,10}$/;
      } else {
        regEn = /^[(\u4e00-\u9fff)]{2,10}$/;
      }
      if (!regEn.test(value)) {
        callback(new Error('請輸入2-10位漢字'));
      }
      callback();
    },
    isBranchName(rule, value, callback) {
      let regEn = /^[\u4e00-\u9fff]{2,20}$/;
      if (!regEn.test(value)) {
        callback(new Error('請輸入2-20位漢字'));
      }
      callback();
    },
    isIdentity(rule, value, callback) {
      let regEn = /^[^\u3002\uff1b\uff0c\uff1a\u201c\u201d\uff08\uff09\u3001\uff1f\u300a\u300b]{10,14}$/;
      if (!regEn.test(value)) {
        callback(new Error('請輸入10-14位正確的身份證字號'));
      }
      callback();
    },
    isChinaIdentify(rule, value, callback) {
      let regEn = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{3}[\dXx]$/;
      if (!regEn.test(value)) {
        callback(new Error('请输入正确的身份证号码'));
      }
      callback();
    },
    isPermanent(rule, value, callback) {
      let regEn = /^([^\x00-\xff]|[A-Za-z0-9_-])+$/;
      if (!regEn.test(value)) {
        callback(new Error('請輸入正確的戶籍地址'));
      }
      callback();
    },
    // 驗證身份證圖片
    handleAvatarSuccessP({ file }) {
      const fd = new FormData();
      fd.append('file', file);
      uploadImageToS3(fd).then(({ data }) => {
        this.identityFrontImg = data;
        this.dialogImageUrlP = true;
      });
      // this.imageUrl_p = URL.createObjectURL(file.raw);
      // this.identityFrontImg = res.data;
      // this.isImageUrl_P = true;
      // this.dialogImageUrlP = true;
    },
    // 驗證身份證圖片
    handleAvatarSuccessO({ file }) {
      const fd = new FormData();
      fd.append('file', file);
      uploadImageToS3(fd).then(({ data }) => {
        this.identityBackImg = data;
        this.dialogImageUrlO = true;
      });
    },
    // 驗證銀行存摺圖
    handleBankbookSuccess({ file }) {
      const fd = new FormData();
      fd.append('file', file);
      uploadImageToS3(fd).then(({ data }) => {
        this.bankbookImg = data;
        this.dialogImageUrlB = true;
      });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || 'image/jpg' || 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 3;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/JPEG/PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 3MB!');
      }
      return isJPG && isLt2M;
    },
    saveInfo(obj) {
      const { INFO_KEY } = this;
      obj
        ? localStorage.setItem(INFO_KEY, JSON.stringify(obj))
        : localStorage.removeItem(INFO_KEY);
    },
    submitForm() {
      // 審核中不可修改
      if (this.reviewStatus === 'Applying') return;
      if (this.isLoading) return;
      if (!this.identityFrontImg) {
        this.dialogImageUrlP = false;
        return;
      }
      if (!this.identityBackImg) {
        this.dialogImageUrlO = false;
        return;
      }
      if (!this.isPaypal && !this.bankbookImg) {
        this.dialogImageUrlB = false;
        return;
      }
      this.$refs.applyForm.validate(async valid => {
        if (!valid) return false;
        let params = {
          accountNo: this.applyForm.accountNo, //帳戶號碼
          accountUserName: this.applyForm.accountUserName, //真實姓名
          bankName: this.applyForm.bankName, //銀行名稱
          branchName: this.applyForm.branchName, //銀行分行名稱
          identityBackImg: this.identityBackImg, //身份證反面
          bankbookImg: this.bankbookImg, //身份證反面
          identityFrontImg: this.identityFrontImg, //身份證正面
          identityNo: this.applyForm.identityNo, //身份證號
          address: this.applyForm.Permanent, //戶籍地址
          id: this.accountId //標記當前修改的帳號，對用多帳號需求預留
        };
        try {
          const {
            accountNo,
            accountUserName,
            bankName,
            branchName,
            identityNo,
            Permanent
          } = this.applyForm;
          this.saveInfo({
            accountNo,
            accountUserName,
            bankName,
            branchName,
            identityNo,
            Permanent
          });
        } catch (e) {
          this.saveInfo();
        }
        this.isLoading = true;
        saveBankInfo(params)
          .then(res => {
            if (res.code == 200) {
              this.$message.success('提交成功');
              this.$router.back();
            }
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      });
    },
    open() {
      this.dialogVisible = true;
    }
  },
  created() {
    this.initData();
  }
};
</script>
<style lang="scss" scoped>
.withdraw-account-page {
  padding: 44px 48px;
  margin-bottom: 128px !important;
  background: #ffffff;
  border-radius: 8px;
  /deep/ .el-image-viewer__wrapper {
    top: 60px;
  }
  & /deep/ .el-form {
    overflow: hidden;
    .amount {
      position: relative;
      height: 90px;
      & /deep/ .el-form-item__content {
        line-height: 20px;
      }
      .AmountDes {
        position: absolute;
        left: 464px;
        top: 25px;
        font-weight: normal;
        font-size: 12px;
        color: #999999;
        line-height: 17px;
      }
    }
    .el-form-item__label {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #666666;
      padding-bottom: 5px;
      &::before {
        content: '';
      }
    }
    .el-form-item__content {
      .el-form-item__error {
        font-weight: 500;
        font-size: 12px;
        color: #fd2243;
      }
      .el-input {
        .el-input__inner {
          width: 434px;
          background: #f6f6f6;
          border-radius: 4px;
          &::placeholder {
            font-size: 14px;
          }
          &:focus {
            background: #ffffff;
            box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.15);
            border-radius: 4px;
          }
        }
      }
      el-select {
        width: 434px;
        height: 40px;
        background: #f6f6f6;
        border-radius: 4px;
      }
    }
  }
}
.PersonalData {
  overflow: hidden;
  .UploadIDCard {
    width: 505px;
    @include flex(center, top);
    .IDCard_dec {
      width: 200px;
      margin-top: 25px;
      p {
        width: 200px;
        font-size: 12px;
        margin-bottom: 5px;
        color: #999999;
      }
    }
    .UploadIDCard_Positive {
      height: 127px;
      margin-left: 6px;
      .el-upload__text {
        margin-top: 5px;
        font-weight: 500;
        font-size: 12px;
        line-height: 17px;
        color: #fd2243;
      }
      .Positive_title {
        font-weight: 500;
        font-size: 14px;
        color: #666666;
      }
    }
    .UploadIDCard_Verso {
      margin: 0 30px;
      height: 127px;
      .el-upload__text {
        margin-top: 5px;
        font-weight: 500;
        font-size: 12px;
        color: #fd2243;
        line-height: 17px;
      }
      .Verso_title {
        font-weight: 500;
        font-size: 14px;
        color: #666666;
      }
    }
  }
  .el-form-item {
    float: left;
    margin-right: 30px;
  }
  .PersonalData_title {
    margin-bottom: 25px;
    img {
      width: 25px;
      height: 25px;
      vertical-align: middle;
      margin-right: 7px;
    }
    span {
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      vertical-align: middle;
    }
  }
}
.BankInformation {
  overflow: hidden;
  .el-form-item {
    float: left;
    margin-right: 30px;
  }
  .uploadBankbook {
    width: 600px;
    align-items: center;
    @include flex(flex-start, top);
    flex-wrap: wrap;
    .show-exist {
      margin: 0 13px 0 13px;
      font-style: normal;
      font-weight: 500;
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #666666;
    }
    .show-exist-img {
      width: 119px;
      height: 74px;
      position: relative;
      bottom: 3px;
      margin-right: 32px;
    }
    .IDCard_dec {
      width: 200px;
      height: 74px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      p {
        width: 200px;
        font-size: 12px;
        margin-bottom: 5px;
        color: #999999;
      }
    }
    .bankbook {
      .el-upload__text {
        margin-top: 5px;
        font-weight: 500;
        font-size: 12px;
        line-height: 17px;
        color: #fd2243;
      }
    }
  }
  .BankInformation_title {
    margin-bottom: 25px;
    img {
      width: 25px;
      height: 25px;
      vertical-align: middle;
      margin-right: 7px;
    }
    span {
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      vertical-align: middle;
    }
  }
}
.avatar-uploader {
  display: block;
  width: 124px;
  height: 72px;
  border: 2px dashed #e8eaee;
  margin-top: 6px;
  border-radius: 12px;
  /deep/ .el-upload--text {
    width: 100%;
  }
  .avatar-uploader-icon {
    width: 100%;
    height: 70px;
    line-height: 68px;
    text-align: center;
    font-weight: 700;
    font-size: 18px;
    color: #d8d8d8;
  }
  .avatar {
    width: 100%;
    height: 72px;
    border-radius: 4px;
    display: block;
  }
  .el-upload {
    cursor: pointer;
  }
}
.submit-button {
  min-width: 156px;
  margin-top: 56px;
}
.bankbook_title {
  width: 100%;
  font-weight: 500;
  font-size: 14px;
  color: #666666;
}
.example-image {
  display: flex;
  align-items: center;
  overflow: hidden;
  margin-top: 6px;
}
</style>
